import whenDomReady from 'when-dom-ready';
import Stickyfill from 'stickyfilljs';

function initialize() {
  const list = document.querySelector('.js-jump-page-nav-list');

  const ISOPEN = 'is-open';

  bindNavigation(list);

  const nav = document.querySelector('.js-jump-page-nav');
  const scrollLinks = document.querySelectorAll('[data-scroll]');
  const selected = document.querySelector('.js-selected-item');

  if (scrollLinks.length === 0 || list === null || selected === null) {
    return;
  }

  nav.classList.remove('hidden');

  // position:sticky polyfill for IE
  Stickyfill.add(nav);

  function scrollToLink(link) {
    const data = link.getAttribute('data-scroll');
    const el = document.querySelector(`[data-navigation-id="${data}"]`);
    const selectedText = link.textContent;

    const contentPos = el.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: contentPos - 60,
      left: 0,
      behavior: 'smooth',
    });

    if (list.classList.contains(ISOPEN)) {
      selected.textContent = selectedText;
      list.classList.remove(ISOPEN);
    } else {
      selected.textContent = 'Select...';
    }
  }

  Array.from(scrollLinks).forEach(link => {
    link.addEventListener('click', () => {
      scrollToLink(link);
    });
  });

  selected.addEventListener('click', () => {
    if (!list.classList.contains(ISOPEN)) {
      list.classList.add(ISOPEN);
    } else {
      list.classList.remove(ISOPEN);
    }
  });
}

function bindNavigation(navigationList) {
  const navItems = document.querySelectorAll('[data-navigation-title]');

  for (let i = 0; i < navItems.length; i += 1) {
    const navItemText = navItems[i].dataset.navigationTitle;
    const navigationId = navItems[i].dataset.navigationId;

    if (navItemText && navigationId) {
      const navScrollListElement = document.createElement('li');
      navScrollListElement.className = 'sticky-jump-page-nav__list-item';

      const navScrollLink = document.createElement('a');
      navScrollLink.setAttribute('data-scroll', navigationId);
      navScrollLink.className = 'js-smooth-scroll';
      navScrollLink.textContent = navItemText;

      navScrollListElement.appendChild(navScrollLink);

      navigationList.appendChild(navScrollListElement);
    }
  }
}

whenDomReady().then(initialize);
